module.exports = __webpack_public_path__ + "img/bg_botoom.e4abec33.png";